import { useEffect } from 'react';

import { useTranslate } from '@growtherapy/i18n';

import outOfNowhereToneUri from '../../assets/audio/out-of-nowhere-tone.mp3?url';
import { gracefullyPlayAudio } from '../../audio';
import { useActiveBrand } from '../../components/branding/useActiveBrand';
import { NOTIFICATION_VOLUME } from '../../config';
import { setAlertTitle } from '../../metadata';
import { debounce } from '../../utils';
import { useClearProviderNoShowTabTitleCallback } from './useClearProviderNoShowTabTitle';
import { useRecordProviderNoShowReportCallback } from './useRecordProviderNoShowReportCallback';

const DEBOUNCE_TIME_MS = 1000;

const playPastProviderGracePeriodSound = debounce(() => {
  const ringtone = new Audio(outOfNowhereToneUri);
  ringtone.volume = NOTIFICATION_VOLUME;
  gracefullyPlayAudio(ringtone);
}, DEBOUNCE_TIME_MS);

export function useUpdateTitleOnProviderPastNoShowThreshold() {
  const activeBrand = useActiveBrand();
  const t = useTranslate();
  const { isPastNoShowThreshold } = useRecordProviderNoShowReportCallback();
  const clearProviderNoShowTabTitle = useClearProviderNoShowTabTitleCallback();
  const providerNoShowTitle = t('telehealth-core:meta.providerNotHere');

  useEffect(
    function showProviderNotHereTabTitle() {
      if (!isPastNoShowThreshold) return;
      setAlertTitle(providerNoShowTitle, activeBrand);
      playPastProviderGracePeriodSound();
    },
    [providerNoShowTitle, isPastNoShowThreshold, activeBrand],
  );

  useEffect(function resetProviderNoShowTitleOnLeaveWaitingRoom() {
    return () => {
      if (document.title !== providerNoShowTitle) return;
      clearProviderNoShowTabTitle();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
